export default __webpack_public_path__ + "static/media/HTHRP_icon.7d7aba59.png";